import React from 'react';
import { Table as MuiTable, type TableProps } from '@mui/material';

export type DataSheetProps = TableProps;

export default function DataSheet({ children, ...props }: DataSheetProps) {
  return <MuiTable {...props}>{children}</MuiTable>;
}
